import { makeStyles } from '@material-ui/core';

const BORDER_COLOR = '#CFF0E6';

export default makeStyles(theme => ({
  root: {
    display: 'grid',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
  },
  button: {
    justifySelf: 'end',
  },
  filesSection: {
    display: 'grid',
    gap: theme.spacing(0),
    background: theme.palette.common.white,
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: 8,
    boxShadow: '0 10px 26px rgba(16, 24, 40, 0.06)',
    overflow: 'hidden',
  },
  documentRow: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  documentInfo: {
    display: 'grid',
    gap: theme.spacing(0.75),
    minWidth: 0,
  },
  documentName: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    wordBreak: 'break-word',
  },
  documentDescription: {
    color: theme.palette.text.secondary,
    '& p': {
      margin: 0,
    },
  },
  documentActions: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 32px)',
    gap: theme.spacing(1),
    justifyContent: 'end',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'start',
    },
  },
  emptyState: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(3),
    textAlign: 'center',
  },
}));
